/* eslint-disable quotes */
const Routes = {
  toDashboard: () => `/`,
  toRigs: () => `/rigs`,
  toUsers: () => `/users`,
  toQCSummary: (deviceType = ':deviceType') => `/qc/${deviceType}`,
};

export default Routes;
